import { render, staticRenderFns } from "./clientdashboard-ledger.vue?vue&type=template&id=aad5c794&"
import script from "./clientdashboard-ledger.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-ledger.vue?vue&type=script&lang=js&"
import style0 from "./clientdashboard-ledger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports